import React from 'react';
import StyledTableCell from 'components/Table/StyledTableCell';

const Stock = ({ item }) => {
	return <StyledTableCell style={{ minWidth: 70, maxWidth: 70, width: 70 }}>{item.quantity}</StyledTableCell>;
};

export default Stock;
